var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#35C4F9;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F1F2F2;}\n\t.st3{fill:#C3C3ED;}\n\t.st4{fill:#616161;}\n\t.st5{fill:#EDB277;}\n\t.st6{fill:#3C2516;}\n\t.st7{fill:#E6E7E8;}\n\t.st8{fill:#182746;}\n\t.st9{fill:#808285;}\n\t.st10{fill:#364D81;}\n\t.st11{fill:#4C72B1;}\n\t.st12{fill:#293F68;}\n\t.st13{fill:#1F3C68;}\n\t.st14{fill:#192A48;}\n\t.st15{fill:#58595B;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_173_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_120_",
    className: "st0",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2912_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2950_",
    className: "st1",
    points: "144.6,200 143.8,119.2 124.9,115 74.7,115 55.7,119.2 55.4,200  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2949_",
    className: "st1",
    d: "M170.1,200c-2.4-14.3-13.1-68.8-17.6-75.3c-4.8-7-10.5-5.9-10.5-5.9v48.2 c0,0,5.1,24.9,6.7,33.1H170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2948_",
    className: "st1",
    d: "M51.4,200c1.9-8.9,7.9-36.2,7.9-36.2l-1.1-45.1c0,0-5.8-1.1-10.5,5.9 c-4.4,6.5-15.3,61-17.7,75.3H51.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2935_",
    className: "st2",
    points: "75.2,134 96.6,200 99.2,200 84.3,113.1 74.9,113.8 72.9,121.4 78.6,128.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2934_",
    className: "st2",
    points: "102.9,200 124.4,134 121,128.1 126.7,121.4 124.6,114.3 115.3,113.1 100.3,200 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2931_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2933_",
    className: "st3",
    points: "102.2,189 115.3,113.1 84.3,113.1 97.4,189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_41_",
    className: "st3",
    points: "115.3,105.2 115.3,113.1 84.3,113.1 84.3,105.2 99.8,108.5  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2930_",
    className: "st4",
    d: "M99.2,200h1.2l5.2-30.7l-2.4-48.7c0,0,1.1-3.3,1.5-5.2c0.5-2.6-3.5-5.4-4.9-5.4 c-1.4,0-5.4,2.8-4.9,5.4c0.4,1.9,1.5,5.2,1.5,5.2L94,169.3L99.2,200z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2870_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2947_",
    className: "st5",
    d: "M117.9,38.5H82.2c-6.9,0-12.5,5.6-12.5,12.5v32c0,14.2,14.9,25.8,29.1,25.8h2.2 c14.3,0,29.3-11.7,29.3-26V50.9C130.4,44.1,124.8,38.5,117.9,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2946_",
    className: "st6",
    d: "M130.8,34.7c-0.5-0.8-0.8-1.2-0.8-2.2c0-2.3,1.2-3.1,1.2-3.1s-0.8-0.5-1.9-0.4 c-1,0.2-1.5,0.3-1.5,0.3s1.1-1.5,2.8-2c1.7-0.6,3.1-0.9,3.1-0.9s-29.9-6.6-41.1-3.8C96.6,27.2,124.8,33,130.8,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2943_",
    className: "st5",
    d: "M71.1,68.4c0,0-4.9-2.9-5.6,4.3c-0.7,7.2,1.8,11.6,3.3,12.5c1.5,1,2.3,0.7,2.3,0.7V68.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2942_",
    className: "st5",
    d: "M128.3,68.4c0,0,4.9-2.9,5.6,4.3c0.7,7.2-1.8,11.6-3.3,12.5c-1.5,1-2.3,0.7-2.3,0.7V68.4 z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2941_",
    x: 69.5,
    y: 50.2,
    width: 58.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2914_",
    className: "st6",
    d: "M73.1,47c0,0,10.8,5.7,29,6.5s24-3.2,24-3.2s1.6,5.7,2.6,12.9s1.6,13.7,1.6,13.7 s4.7-10.9,4.3-23.5c-0.4-12.6-1.8-20.9-11.5-27.1c-9.7-6.2-32.6-7.8-42.3-2.7c-9.7,5.2-9.8,9.1-9.8,9.1s-7.3,5.7-7.7,21.5 c-0.3,13.1,6.2,22.6,6.2,22.6s0.9-12.4,1.8-19.2C72,51.6,73.1,47,73.1,47z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2913_",
    className: "st7",
    cx: 100.6,
    cy: 45.7,
    r: 10.4
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st8",
    d: "M84.4,113.1c-0.1,0.2-0.1,0.4-0.1,0.4s-6.5,6.5-8.2,18.7c-1.7,12.1,0,32.2,0,32.2h-2.9 c0,0-1.9-16.1,0.2-32.3c1.8-13.7,8.8-20,10.9-21.5v2.6H84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st8",
    d: "M115.3,112.6c0.1,0.3,0.1,0.6,0.1,0.6s7.2,7.5,8.9,19.7c0.2,1.7,0.4,3.5,0.5,5.5 c0,0.5,0,1.1,0,1.6h2.9c0-0.5,0-1.1,0-1.6c-0.2-1.8-0.4-3.7-0.7-5.6c-2.2-14.2-9.9-21.3-11.7-22.8V112.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st9",
    d: "M134.5,179.6c0,0,5.4-0.6,6.2-3.5c0.8-2.9,0.8-3.8-0.2-7.8c-1-3.9-3.8-12.4-3.8-12.4l0.9-0.4 c0,0,2.3,6,3.4,10.3c1.1,4.2,1.9,7.6,0.6,10.8c-1.3,3.3-6.1,4-6.3,4c-0.7,0.1-1.1,0-1.1,0L134.5,179.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st10",
    d: "M132.9,181.3c0,0,2.1,0.5,1.9-1.1c-0.1-1.5-1.1-1.2-1.5-1.1c-0.3,0-0.7,0.2-0.7,0.2 L132.9,181.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st10",
    d: "M131.1,181.6c0,0,0.7,0.7,1.8,0.2c1.1-0.5,1.1-2.5,0.1-2.9c-1-0.4-1.6-0.1-1.8,0 c-0.2,0.1-0.6,0.6-0.5,1.3C130.7,180.9,130.9,181.5,131.1,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st8",
    d: "M133.5,181.4C133.5,181.4,133.5,181.4,133.5,181.4c0.5-0.6,0.5-1.7,0-2.3c0,0-0.1,0-0.1,0 C133.9,179.7,133.9,180.8,133.5,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st11",
    d: "M131,181.6c0,0,0.7-0.3,0.7-1.2c-0.1-0.7-0.2-0.8-0.4-1.1c-0.1-0.1-0.2-0.2-0.2-0.2 s-0.3,0.5-0.3,1.2C130.8,181.3,131,181.6,131,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st12",
    d: "M131,181.6c0,0,0.6-0.4,0.5-1.2c0-0.8-0.6-1.2-0.6-1.2s-0.3,0.3-0.2,1.2 C130.8,181.2,131,181.6,131,181.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_25_",
    className: "st13",
    cx: 131.2,
    cy: 180.4,
    rx: 0.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_24_",
    className: "st14",
    cx: 131.2,
    cy: 180.4,
    rx: 0.1,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_22_",
    className: "st8",
    points: "136.7,156.6 138,156.1 135.7,150.9 134.4,151.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st9",
    d: "M118.2,179.6c0,0-5.4-0.6-6.2-3.5c-0.8-2.9-0.8-3.8,0.2-7.8c1-3.9,3.8-12.4,3.8-12.4 l-0.9-0.4c0,0-2.3,6-3.4,10.3s-1.9,7.6-0.6,10.8s6.1,4,6.3,4c0.7,0.1,1.1,0,1.1,0L118.2,179.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st10",
    d: "M119.8,181.3c0,0-2.1,0.5-1.9-1.1c0.1-1.5,1.1-1.2,1.5-1.1c0.3,0,0.7,0.2,0.7,0.2 L119.8,181.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st10",
    d: "M121.6,181.6c0,0-0.7,0.7-1.8,0.2c-1.1-0.5-1.1-2.5-0.1-2.9c1-0.4,1.6-0.1,1.8,0 c0.2,0.1,0.6,0.6,0.5,1.3C122,180.9,121.8,181.5,121.6,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st8",
    d: "M119.2,181.4C119.2,181.4,119.2,181.4,119.2,181.4c-0.5-0.6-0.5-1.7,0-2.3c0,0,0.1,0,0.1,0 C118.8,179.7,118.8,180.8,119.2,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st11",
    d: "M121.7,181.6c0,0-0.7-0.3-0.7-1.2c0.1-0.7,0.2-0.8,0.4-1.1c0.1-0.1,0.2-0.2,0.2-0.2 s0.3,0.5,0.3,1.2C121.9,181.3,121.7,181.6,121.7,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st12",
    d: "M121.7,181.6c0,0-0.6-0.4-0.5-1.2c0-0.8,0.6-1.2,0.6-1.2s0.3,0.3,0.2,1.2 C121.9,181.2,121.7,181.6,121.7,181.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_15_",
    className: "st13",
    cx: 121.5,
    cy: 180.4,
    rx: 0.3,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_14_",
    className: "st14",
    cx: 121.5,
    cy: 180.4,
    rx: 0.1,
    ry: 0.3
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12_",
    className: "st8",
    points: "116,156.6 114.7,156.1 117,150.9 118.3,151.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st8",
    d: "M118.1,153.1l-2-1.1c0,0,3-7,9.8-6.9c6.8,0.1,9.1,4.4,9.6,5c0.5,0.6,1,1.7,1,1.7l-1.9,1.3 c0,0-3.3-5.9-8.6-5.5C120,148.1,118.1,153.1,118.1,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st8",
    d: "M122.8,145.6l7.2,0.1c0,0-2.2-1.2-2.2-2.1s-0.1-5.2-0.1-5.2h-2.8c0,0,0.1,4.3,0,5.1 C124.8,144.3,122.8,145.6,122.8,145.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_8_",
    className: "st9",
    cx: 74.9,
    cy: 171.7,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_7_",
    className: "st7",
    cx: 74.9,
    cy: 171.7,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6_",
    className: "st9",
    cx: 74.9,
    cy: 171.7,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5_",
    className: "st2",
    cx: 74.9,
    cy: 171.7,
    r: 4.7
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3_",
    className: "st15",
    cx: 74.9,
    cy: 171.7,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleDoc);
export default __webpack_public_path__ + "static/media/male_doc.538b3a0002aec56f0af428601e3c8a12.svg";
export { ForwardRef as ReactComponent };